import { APP_INITIALIZER, Inject, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
/**功能module */
import { HomeModule } from './pages/home/home.module';
/**NG-ZORRO */
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { DetailApplicationModule } from './pages/main/module/detail-application/detail-application.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ApiConfiguration } from './sdk/api-configuration';
import { Lb4ApiService } from './shared/service/api/lb4-api.service';
import { DatePipe, registerLocaleData } from '@angular/common';
import { LoginModule } from './pages/login/login.module';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import zh from '@angular/common/locales/zh';
import { MatomoModule } from 'ngx-matomo';
import { JwtInterceptor } from './shared/interceptors/jwt.interceptor';

registerLocaleData(zh);

export function loadFactory(
  lb4Api: Lb4ApiService,
  apiConfiguration: ApiConfiguration
) {
  return async () => {
    apiConfiguration.rootUrl = await lb4Api.getLoopBackApi();
    lb4Api.configUrl = apiConfiguration.rootUrl;
  };
}
// AoT
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    DetailApplicationModule,
    HomeModule,
    ReactiveFormsModule,
    LoginModule,
    TranslateModule.forRoot({
      loader: {//loader中的provide代表将TranslateLoader注入进来，而他的实现是由useFactory的HttpLoaderFactory来具体实现。
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MatomoModule,
    // MatomoModule.forRoot(environment.matomoConfig),
    // MatomoModule.forRoot({
    //   // scriptUrl: '//matomo-wzs.wistron.com/matomo.js',
    //   trackers: [
    //     {
    //       trackerUrl: "https://matomo-wzs.wistron.com/",
    //       siteId: 24
    //     }
    //   ],
    //   skipTrackingInitialPageView: false,
    //   requireConsent: true,
    //   routeTracking: {
    //     enable: true
    //   }
    // })
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: loadFactory,
      deps: [Lb4ApiService, ApiConfiguration],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private translateService: TranslateService, @Inject(LOCALE_ID) locale: string) {
    if (environment.supportedLocale.indexOf(locale) === -1) {
      if (localStorage.getItem('language')) {
        locale = localStorage.getItem('language');
      }
      else {
        locale = "zh_CN";//"language":[{"lable":"English","value":"en"},{"lable":"简体中文","value":"zh_CN"},{"lable":"繁體中文","value":"zh_TW"}] 初始化
      }
    }
    this.translateService.use(locale);
  }
}
